import style from './style.module.scss'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name?: string
  value?: string
  checked?: boolean
}

const Checkbox = ({ name, value, checked, ...props }: Props) => {
  return (
    <label className={style.checkbox}>
      <input name={name || 'checkbox'} value={value} type="checkbox" checked={checked} {...props} />
      <span></span>
    </label>
  )
}

export default Checkbox
